const formFieldsInbound = [
  {
    key: 'materialTypeName',
    label: 'Material / Type',
    type: 'text',
    isRequired: true,
  },
  {
    key: 'supplierName',
    label: 'Supplier Name',
    type: 'text',
  },
  {
    key: 'newDestination',
    label: 'New Destination',
    type: 'text',
  },
  {
    key: 'shippingMethod',
    label: 'Shipping Method',
    type: 'select',
    options: [{ label: 'Ground', value: 'Ground' }],
  },
  { type: 'autocomplete' },
];

export { formFieldsInbound };
